import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.1.0-alpha';

function clamp01(x){
  return Number.isFinite(x)?Math.max(0,Math.min(1,x)):null;
}

function norm(x){
  x=x||{};
  return Object.freeze({
    symbol:x.symbol||null,
    evidenceCoverage:clamp01(x.evidenceCoverage),
    verifiedCoverage:clamp01(x.verifiedCoverage),
    freshnessCoverage:clamp01(x.freshnessCoverage),
    lineageCoverage:clamp01(x.lineageCoverage),
    unresolvedConflicts:Number.isFinite(x.unresolvedConflicts)?Math.max(0,Math.floor(x.unresolvedConflicts)):0,
    orphanClaims:Number.isFinite(x.orphanClaims)?Math.max(0,Math.floor(x.orphanClaims)):0,
    orphanConclusions:Number.isFinite(x.orphanConclusions)?Math.max(0,Math.floor(x.orphanConclusions)):0,
    contractErrors:Number.isFinite(x.contractErrors)?Math.max(0,Math.floor(x.contractErrors)):0,
    consistencyErrors:Number.isFinite(x.consistencyErrors)?Math.max(0,Math.floor(x.consistencyErrors)):0,
    consistencyReviews:Number.isFinite(x.consistencyReviews)?Math.max(0,Math.floor(x.consistencyReviews)):0
  });
}

function state(x){
  const n=norm(x);
  if(n.contractErrors>0 || n.consistencyErrors>0 || n.orphanConclusions>0) return 'BROKEN';
  if(n.unresolvedConflicts>0 || n.orphanClaims>0) return 'REVIEW';

  const required=[n.evidenceCoverage,n.verifiedCoverage,n.freshnessCoverage,n.lineageCoverage];
  if(required.some(v=>v===null)) return 'INSUFFICIENT_DATA';

  const floor=Math.min(...required);
  if(floor<0.5) return 'WEAK';
  if(floor<0.75 || n.consistencyReviews>0) return 'REVIEW';
  return 'HEALTHY';
}

function reasons(x){
  const n=norm(x),r=[];
  if(n.contractErrors) r.push(`${n.contractErrors} contract error(s)`);
  if(n.consistencyErrors) r.push(`${n.consistencyErrors} cross-engine consistency error(s)`);
  if(n.orphanConclusions) r.push(`${n.orphanConclusions} orphan conclusion(s)`);
  if(n.orphanClaims) r.push(`${n.orphanClaims} orphan claim(s)`);
  if(n.unresolvedConflicts) r.push(`${n.unresolvedConflicts} unresolved conflict(s)`);
  if(n.evidenceCoverage!==null && n.evidenceCoverage<0.75) r.push('evidence coverage incomplete');
  if(n.verifiedCoverage!==null && n.verifiedCoverage<0.75) r.push('verified evidence coverage incomplete');
  if(n.freshnessCoverage!==null && n.freshnessCoverage<0.75) r.push('freshness coverage incomplete');
  if(n.lineageCoverage!==null && n.lineageCoverage<0.75) r.push('lineage coverage incomplete');
  if(n.consistencyReviews) r.push(`${n.consistencyReviews} consistency review(s)`);
  return Object.freeze(r);
}

function assess(x){
  const n=norm(x),s=state(n);
  return Object.freeze({
    symbol:n.symbol,
    state:s,
    reasons:reasons(n),
    usableForResearch:s!=='BROKEN',
    decisionReady:s==='HEALTHY',
    tradeSignal:false,
    capitalPermission:false,
    universalScore:null
  });
}

function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const healthy={symbol:'AAA',evidenceCoverage:.9,verifiedCoverage:.9,freshnessCoverage:.85,lineageCoverage:.95};
  ok('healthy state recognized',state(healthy)==='HEALTHY');
  ok('healthy assessment decision ready',assess(healthy).decisionReady===true);

  ok('contract error breaks integrity',state({...healthy,contractErrors:1})==='BROKEN');
  ok('consistency error breaks integrity',state({...healthy,consistencyErrors:1})==='BROKEN');
  ok('orphan conclusion breaks integrity',state({...healthy,orphanConclusions:1})==='BROKEN');

  ok('unresolved conflict requires review',state({...healthy,unresolvedConflicts:1})==='REVIEW');
  ok('orphan claim requires review',state({...healthy,orphanClaims:1})==='REVIEW');
  ok('consistency review prevents healthy state',state({...healthy,consistencyReviews:1})==='REVIEW');

  ok('missing coverage yields insufficient data',state({...healthy,lineageCoverage:null})==='INSUFFICIENT_DATA');
  ok('weak floor detected',state({...healthy,verifiedCoverage:.4})==='WEAK');
  ok('sub-75 percent floor requires review',state({...healthy,freshnessCoverage:.7})==='REVIEW');

  const a=assess({...healthy,contractErrors:1});
  ok('broken state not usable for research',a.usableForResearch===false);
  ok('broken state not decision ready',a.decisionReady===false);
  ok('reasons expose contract error',a.reasons.some(x=>x.includes('contract')));
  ok('no trade signal',a.tradeSignal===false);
  ok('no capital permission',a.capitalPermission===false);
  ok('no universal score',a.universalScore===null);

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

const API={VERSION,norm,state,reasons,assess,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestResearchIntegrityHealthEngine=Object.freeze(API);
})(engineContext);